/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createNot } from '../../factoriesAny.js';
export var notDependencies = {
  typedDependencies: typedDependencies,
  createNot: createNot
};